import { Component, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';

import { NotifyService } from '../notify.service';

@Component({
  selector: 'notify-container',
  templateUrl: './notify-container.component.html',
  styleUrls: ['./notify-container.component.scss']
})
export class NotifyContainerComponent implements AfterViewInit {

  @ViewChild('modalContainer', { read: ViewContainerRef })
  public modalContainerRef: ViewContainerRef;

  @ViewChild('toastContainer', { read: ViewContainerRef })
  public toastContainerRef: ViewContainerRef;

  constructor(
    private notifyService: NotifyService
  ) { }

  ngAfterViewInit() {
    this.notifyService.setContainer(this);
  }

  public getModalContainer(): ViewContainerRef {
    return this.modalContainerRef;
  }

  public getToastContainer(): ViewContainerRef {
    return this.toastContainerRef;
  }

}



// WEBPACK FOOTER //
// /dist/src/app/notify/notify-container/notify-container.component.ts